export default __webpack_public_path__ + "static/media/empEzy2.361cdfab.jpg";